import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

/** A translation job currently in progress (non-terminal status). */
export type ActiveTranslationJob = {
  __typename?: 'ActiveTranslationJob';
  /** TRANSCOM client identity that owns the source (e.g. LangHub, Transcom, Panther). */
  clientId: Scalars['String'];
  /** Epoch milliseconds when translations are expected by — SLA deadline (stringified Long). */
  dueDate: Scalars['String'];
  /** Namespace this job belongs to. */
  namespaceId: Scalars['String'];
  /** Epoch milliseconds when this job was sent for translation (stringified Long). */
  sentForTranslationDate: Scalars['String'];
  /** String group being translated. */
  stringGroupId: Scalars['String'];
  /** Version of the string group submitted for translation. */
  stringGroupVersion: Scalars['String'];
  /** Tracking identifier for this active job. */
  trackingId: Scalars['String'];
  /** Translation lifecycle status (reuses TranslationStatus from searchTypes). */
  translationStatus: TranslationStatus;
};

/** Paginated list of active translation jobs. */
export type ActiveTranslationJobsConnection = {
  __typename?: 'ActiveTranslationJobsConnection';
  /** Non-null but may be empty ([]) for namespaces with no active jobs. */
  items: Array<ActiveTranslationJob>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AllLocalesResponse = {
  __typename?: 'AllLocalesResponse';
  locales: Array<Scalars['String']>;
};

/** Response for cancelling an in-flight translation. */
export type CancelStringGroupTranslationResponse = {
  __typename?: 'CancelStringGroupTranslationResponse';
  stringGroupId: Scalars['String'];
  version: Scalars['Float'];
};

export type CxFamiliesList = {
  __typename?: 'CxFamiliesList';
  cxFamilies: Array<CxFamilySummary>;
  nextToken?: Maybe<Scalars['String']>;
};

export type CxFamilyDetail = {
  __typename?: 'CxFamilyDetail';
  cxFamilyId: Scalars['String'];
  cxIds: Array<CxIdDetail>;
  sourceLocales: Array<Scalars['String']>;
};

export type CxFamilyDetailResponse = {
  __typename?: 'CxFamilyDetailResponse';
  cxFamily: CxFamilyDetail;
};

export type CxFamilySummary = {
  __typename?: 'CxFamilySummary';
  cxFamilyId: Scalars['String'];
  cxIds: Array<Scalars['String']>;
};

export type CxIdDetail = {
  __typename?: 'CxIdDetail';
  cxId: Scalars['String'];
  sourceLocales: Array<Scalars['String']>;
};

/** A historical (completed/cancelled/failed) translation job. */
export type HistoricalTranslationJob = {
  __typename?: 'HistoricalTranslationJob';
  /** TRANSCOM client identity that owns the source. */
  clientId: Scalars['String'];
  /** Epoch milliseconds when translations were delivered (stringified Long). Null for cancelled/failed jobs. */
  deliveredOnDate?: Maybe<Scalars['String']>;
  /** Namespace this job belongs to. */
  namespaceId: Scalars['String'];
  /** Epoch milliseconds when this job was sent for translation (stringified Long). */
  sentForTranslationDate: Scalars['String'];
  /** String group that was translated. */
  stringGroupId: Scalars['String'];
  /** Version of the string group. */
  stringGroupVersion: Scalars['String'];
  /** Tracking identifier for this historical job. */
  trackingId: Scalars['String'];
  /** Translation lifecycle status (terminal: COMPLETE, CANCELLED, FAILED). */
  translationStatus: TranslationStatus;
};

/** Paginated list of historical translation jobs. */
export type HistoricalTranslationJobsConnection = {
  __typename?: 'HistoricalTranslationJobsConnection';
  /** Non-null but may be empty ([]) for namespaces with no historical jobs. */
  items: Array<HistoricalTranslationJob>;
  nextToken?: Maybe<Scalars['String']>;
};

/** Inline markup type of source strings. */
export enum InlineMarkupType {
  Html = 'HTML',
  Markdown = 'MARKDOWN',
  PlainText = 'PLAIN_TEXT',
}

/** Paginated response for listing string group versions. */
export type ListStringGroupVersionsResponse = {
  __typename?: 'ListStringGroupVersionsResponse';
  nextToken?: Maybe<Scalars['String']>;
  versions: Array<StringGroupVersionSummary>;
};

/** Paginated response for listing strings in a string group version. */
export type ListStringsResponse = {
  __typename?: 'ListStringsResponse';
  nextToken?: Maybe<Scalars['String']>;
  strings: Array<StringInfo>;
};

export enum LocaleType {
  Source = 'SOURCE',
  Target = 'TARGET',
}

/** Message format type of source strings. */
export enum MessageFormatType {
  AmazonMessageFormat = 'AMAZON_MESSAGE_FORMAT',
  HashGet = 'HASH_GET',
  Mustache = 'MUSTACHE',
  None = 'NONE',
}

export type Mutation = {
  __typename?: 'Mutation';
  cancelStringGroupTranslation: CancelStringGroupTranslationResponse;
  submitStringGroupTranslation: SubmitStringGroupTranslationResponse;
  updateUserPreference: UserPreferenceResponse;
};

export type MutationCancelStringGroupTranslationArgs = {
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  version: Scalars['String'];
};

export type MutationSubmitStringGroupTranslationArgs = {
  added?: InputMaybe<Array<StringInfoInput>>;
  baseVersion?: InputMaybe<Scalars['String']>;
  cxIds: Array<Scalars['String']>;
  deleted?: InputMaybe<Array<Scalars['String']>>;
  edited?: InputMaybe<Array<StringInfoInput>>;
  namespaceId: Scalars['String'];
  notificationEmail?: InputMaybe<Scalars['String']>;
  stringGroupId: Scalars['String'];
};

export type MutationUpdateUserPreferenceArgs = {
  input: UpdateUserPreferenceInput;
};

export type Namespace = {
  __typename?: 'Namespace';
  bindleResourceId: Scalars['String'];
  /** Epoch milliseconds when this namespace was created. */
  createdAt: Scalars['Float'];
  createdBy?: Maybe<Scalars['String']>;
  defaultCxFamily?: Maybe<Scalars['String']>;
  namespaceId: Scalars['String'];
  owner?: Maybe<ResourceOwner>;
};

export type NamespaceDetail = {
  __typename?: 'NamespaceDetail';
  namespace: Namespace;
};

export type NamespaceItem = {
  __typename?: 'NamespaceItem';
  namespaceId: Scalars['String'];
};

export type NamespaceList = {
  __typename?: 'NamespaceList';
  namespaces: Array<NamespaceItem>;
  nextToken?: Maybe<Scalars['String']>;
};

/** The kind of resource a permission check targets. */
export enum PermissionResourceType {
  CxFamily = 'CX_FAMILY',
  Namespace = 'NAMESPACE',
}

/** Lifecycle status of the caller's permission-cache sync run. */
export enum PermissionSyncStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
}

/**
 * State of the caller's permission-cache sync, read by the app bootstrap to decide
 * whether to render the app, keep waiting, or ask for a page refresh.
 */
export type PermissionSyncStatusResponse = {
  __typename?: 'PermissionSyncStatusResponse';
  /**
   * Whether the caller has cached permissions that have not expired — i.e. whether
   * there is anything worth rendering. Computed server-side so the expiry window is
   * defined in one place.
   */
  hasUnexpiredCachedPermissions: Scalars['Boolean'];
  /**
   * Epoch milliseconds when the current or most recent run began; null until a run
   * has started.
   *
   * Float rather than the stringified-Long convention used for translation-job
   * dates: the bootstrap does arithmetic on this value (`now - syncStartedAt`
   * against the wait budget), and epoch millis are exactly representable as a
   * double until the year 287396. Matches `Namespace.createdAt`.
   */
  syncStartedAt?: Maybe<Scalars['Float']>;
  /**
   * Status of the current or most recent run. Null when no run has ever been
   * recorded — absence is the "never synced" case, which the bootstrap treats as
   * "the trigger has fired but its status write has not landed yet".
   */
  syncStatus?: Maybe<PermissionSyncStatus>;
};

export type Query = {
  __typename?: 'Query';
  /**
   * Answers which of the named permissions the caller holds on one resource, so the
   * UI can enable or disable actions.
   */
  checkResourcePermissions: ResourcePermissionsResponse;
  describeCxFamily: CxFamilyDetailResponse;
  describeNamespace: NamespaceDetail;
  describeString: StringDetail;
  describeStringGroup: StringGroupDetail;
  /**
   * Reports the state of the caller's permission-cache sync. Pure read — the app
   * bootstrap polls it, so it must stay side-effect free (the sync is started by
   * `getUserProfile`).
   */
  getPermissionSyncStatus: PermissionSyncStatusResponse;
  getUserPreference: UserPreferenceResponse;
  getUserProfile: User;
  /** List translation jobs currently in progress for a given namespace. */
  listActiveTranslationJobs: ActiveTranslationJobsConnection;
  listAllLocales: AllLocalesResponse;
  listCxFamilies: CxFamiliesList;
  listNamespaces: NamespaceList;
  listStringGroupVersions: ListStringGroupVersionsResponse;
  listStringGroups: StringGroupsList;
  listStrings: ListStringsResponse;
  /** List historical (completed/cancelled/failed) translation jobs. */
  listTranslationJobHistory: HistoricalTranslationJobsConnection;
  searchSourceStrings: SourceStringSearchResults;
  searchTranslations: TranslationSearchResults;
};

export type QueryCheckResourcePermissionsArgs = {
  permissions: Scalars['String'];
  resourceId: Scalars['String'];
  resourceType: PermissionResourceType;
};

export type QueryDescribeCxFamilyArgs = {
  cxFamilyId: Scalars['String'];
};

export type QueryDescribeNamespaceArgs = {
  namespaceId: Scalars['String'];
};

export type QueryDescribeStringArgs = {
  cxId?: InputMaybe<Scalars['String']>;
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  stringGroupVersion?: InputMaybe<Scalars['String']>;
  stringId: Scalars['String'];
};

export type QueryDescribeStringGroupArgs = {
  includeStrings?: InputMaybe<Scalars['Boolean']>;
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  stringGroupVersion?: InputMaybe<Scalars['String']>;
};

export type QueryGetUserPreferenceArgs = {
  preferenceKey: UserPreferenceKey;
};

export type QueryListActiveTranslationJobsArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  namespaceId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  stringGroupId?: InputMaybe<Scalars['String']>;
};

export type QueryListAllLocalesArgs = {
  localeType: LocaleType;
};

export type QueryListCxFamiliesArgs = {
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QueryListNamespacesArgs = {
  namespaceIdPrefix?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};

export type QueryListStringGroupVersionsArgs = {
  maxResults?: InputMaybe<Scalars['Int']>;
  namespaceId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  stringGroupId: Scalars['String'];
};

export type QueryListStringGroupsArgs = {
  includeLatestSnapshot?: InputMaybe<Scalars['Boolean']>;
  namespaceId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  stringGroupIdPrefix?: InputMaybe<Scalars['String']>;
};

export type QueryListStringsArgs = {
  maxResults?: InputMaybe<Scalars['Int']>;
  namespaceId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  stringGroupId: Scalars['String'];
  stringGroupVersion?: InputMaybe<Scalars['String']>;
};

export type QueryListTranslationJobHistoryArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  namespaceId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  stringGroupId?: InputMaybe<Scalars['String']>;
};

export type QuerySearchSourceStringsArgs = {
  input: SearchSourceStringsInput;
};

export type QuerySearchTranslationsArgs = {
  input: SearchTranslationsInput;
};

export type ResourceOwner = {
  __typename?: 'ResourceOwner';
  /** Team ID or employee login, depending on ownerType. */
  ownerId?: Maybe<Scalars['String']>;
  ownerType?: Maybe<ResourceOwnerType>;
};

export enum ResourceOwnerType {
  Individual = 'INDIVIDUAL',
  Team = 'TEAM',
}

/** One requested permission name and whether the caller holds it. */
export type ResourcePermission = {
  __typename?: 'ResourcePermission';
  /**
   * False for a permission the caller does not hold, for a resource that does not
   * exist, and for a name the service does not recognise — the three are
   * deliberately indistinguishable, so this answers nothing about existence.
   */
  granted: Scalars['Boolean'];
  /** Permission name exactly as requested (e.g. VIEW, SOURCE_MANAGEMENT). */
  permission: Scalars['String'];
};

/**
 * The caller's own permission bits on one resource. Carries no resource data.
 *
 * A `true` here is a UI hint for enabling a control, never a grant: every mutation
 * is still authorized server-side at request time.
 */
export type ResourcePermissionsResponse = {
  __typename?: 'ResourcePermissionsResponse';
  /** One entry per requested name, in the order requested. */
  permissions: Array<ResourcePermission>;
};

export type SearchFilters = {
  cxFamilies?: InputMaybe<Array<Scalars['String']>>;
  cxIds?: InputMaybe<Array<Scalars['String']>>;
  namespaceIds?: InputMaybe<Array<Scalars['String']>>;
  statuses?: InputMaybe<Array<TranslationStatus>>;
  stringGroupIds?: InputMaybe<Array<Scalars['String']>>;
  translatedLocales?: InputMaybe<Array<Scalars['String']>>;
};

export type SearchSourceStringsInput = {
  exactMatch?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<SearchFilters>;
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  queryText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type SearchTranslationsInput = {
  exactMatch?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<SearchFilters>;
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  queryText?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum SearchType {
  Source = 'SOURCE',
  Translation = 'TRANSLATION',
}

/**
 * Sort field for source-string and translation search. CX family is a filter
 * (`filters.cxFamilies`), not a sort option.
 */
export enum SortBy {
  Created = 'CREATED',
  LastUpdated = 'LAST_UPDATED',
  Namespace = 'NAMESPACE',
  Status = 'STATUS',
  StringGroupId = 'STRING_GROUP_ID',
  StringId = 'STRING_ID',
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type SourceStringResult = {
  __typename?: 'SourceStringResult';
  groupVersion: Scalars['String'];
  namespaceId: Scalars['String'];
  sourceContent: Scalars['String'];
  status: TranslationStatus;
  stringGroupId: Scalars['String'];
  stringId: Scalars['String'];
  variant?: Maybe<Scalars['String']>;
};

export type SourceStringSearchResults = {
  __typename?: 'SourceStringSearchResults';
  items: Array<SourceStringResult>;
  nextToken?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

export type StringDetail = {
  __typename?: 'StringDetail';
  /**
   * TRANSCOM anchor for this string. Empty in variant view — TRANSCOM has no
   * per-variant anchor yet.
   */
  anchorId?: Maybe<Scalars['String']>;
  /**
   * TRANSCOM client identity that owns this string group's source. Determines which
   * CMS may edit the source text — only `LangHub`-owned sources are editable here.
   * Non-null — mirrors the @required clientId member in the DescribeStringResponse
   * Smithy contract.
   */
  clientId: Scalars['String'];
  contextNote?: Maybe<Scalars['String']>;
  cxFamilyId: Scalars['String'];
  cxIds: Array<Scalars['String']>;
  /**
   * Inline markup type of the source text. Optional — absent when TRANSCOM reports
   * an UNKNOWN format, and for backfilled or non-LangHub strings.
   */
  inlineMarkupType?: Maybe<InlineMarkupType>;
  /**
   * Message format type of the source text. Optional — absent when TRANSCOM reports
   * an UNKNOWN format, and for backfilled or non-LangHub strings.
   */
  messageFormatType?: Maybe<MessageFormatType>;
  resolvedCxId?: Maybe<Scalars['String']>;
  sourceLocale: Scalars['String'];
  sourceText: Scalars['String'];
  stringGroupVersion: Scalars['String'];
  stringId: Scalars['String'];
  translationProgress: TranslationProgress;
  /**
   * Translations for this string. Scoped to the requested cxId and/or
   * stringGroupVersion when those filters are passed. Non-null — mirrors the
   * @required translations member in the DescribeStringResponse Smithy contract.
   */
  translations: Array<Translation>;
  /** Epoch milliseconds when this string was last updated. */
  updatedAt?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  variants?: Maybe<Array<StringVariant>>;
};

/** Full metadata for a string group, returned by describeStringGroup. */
export type StringGroupDetail = {
  __typename?: 'StringGroupDetail';
  clientId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['Float']>;
  cxFamilyId: Scalars['String'];
  cxIds: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  namespaceId: Scalars['String'];
  sourceLocale?: Maybe<Scalars['String']>;
  stringCount: Scalars['Int'];
  stringGroupId: Scalars['String'];
  /** Complete source snapshot when includeStrings=true; empty otherwise. */
  strings: Array<StringInfo>;
  teamName?: Maybe<Scalars['String']>;
  translationProgress: TranslationProgress;
  translationStatus: TranslationStatus;
  updatedBy?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['Float']>;
  /** Monotonic version counter. */
  version: Scalars['Float'];
};

export type StringGroupItem = {
  __typename?: 'StringGroupItem';
  clientId?: Maybe<Scalars['String']>;
  /** Epoch milliseconds when this string group was created. */
  createdAt?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  latestVersion?: Maybe<StringGroupVersionMetadata>;
  stringGroupId: Scalars['String'];
  teamName?: Maybe<Scalars['String']>;
};

export type StringGroupVersionMetadata = {
  __typename?: 'StringGroupVersionMetadata';
  cxFamilyId: Scalars['String'];
  cxIds: Array<Scalars['String']>;
  sourceLocale?: Maybe<Scalars['String']>;
  stringCount: Scalars['Int'];
  /** Epoch milliseconds when this string group version was last updated. */
  updatedAt?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
};

/** A single version entry in the string group's history. */
export type StringGroupVersionSummary = {
  __typename?: 'StringGroupVersionSummary';
  changeSummary?: Maybe<VersionChangeSummary>;
  stringCount: Scalars['Int'];
  translationStatus: TranslationStatus;
  updatedBy?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['Float']>;
  version: Scalars['Float'];
};

export type StringGroupsList = {
  __typename?: 'StringGroupsList';
  nextToken?: Maybe<Scalars['String']>;
  stringGroups: Array<StringGroupItem>;
};

/** A single string within a string group. */
export type StringInfo = {
  __typename?: 'StringInfo';
  contextNote?: Maybe<Scalars['String']>;
  inlineMarkupType?: Maybe<InlineMarkupType>;
  messageFormatType?: Maybe<MessageFormatType>;
  sourceLocale: Scalars['String'];
  sourceText: Scalars['String'];
  status?: Maybe<TranslationStatus>;
  stringId: Scalars['String'];
  variants: Array<StringVariant>;
};

/** Input for a string being submitted (added or edited). */
export type StringInfoInput = {
  contextNote?: InputMaybe<Scalars['String']>;
  inlineMarkupType?: InputMaybe<InlineMarkupType>;
  messageFormatType?: InputMaybe<MessageFormatType>;
  sourceLocale: Scalars['String'];
  sourceText: Scalars['String'];
  stringId: Scalars['String'];
  variants?: InputMaybe<Array<StringVariantInput>>;
};

/** A CX-ID-specific variant override for a string. */
export type StringVariant = {
  __typename?: 'StringVariant';
  contextNote?: Maybe<Scalars['String']>;
  cxId: Scalars['String'];
  sourceText: Scalars['String'];
};

/** Input for a CX-ID-specific variant override. */
export type StringVariantInput = {
  contextNote?: InputMaybe<Scalars['String']>;
  cxId: Scalars['String'];
  sourceText: Scalars['String'];
};

/** Response for submitting a string group for translation. */
export type SubmitStringGroupTranslationResponse = {
  __typename?: 'SubmitStringGroupTranslationResponse';
  stringGroupId: Scalars['String'];
  version: Scalars['Float'];
};

export type Translation = {
  __typename?: 'Translation';
  locale: Scalars['String'];
  status: Scalars['String'];
  translatedText: Scalars['String'];
};

/** Locale-level progress breakdown for a string group version. */
export type TranslationProgress = {
  __typename?: 'TranslationProgress';
  /** Locales left untranslated because the version was cancelled ("NA due to cancellation"). */
  cancelledLocales: Array<Scalars['String']>;
  completedLocales: Array<Scalars['String']>;
  failedLocales: Array<Scalars['String']>;
  inProgressLocales: Array<Scalars['String']>;
};

export type TranslationResult = {
  __typename?: 'TranslationResult';
  groupVersion: Scalars['String'];
  /**
   * Target locale of this translation, in hyphenated BCP-47 form (e.g. `de-DE`,
   * `es-ES`). TRANSCOM is the upstream source of this value and emits hyphens
   * (`TargetString.getLocale()` documents `"es-ES"`);
   * `TranscomResponseMapper.toTargetString` passes it through unnormalized and the
   * OpenSearch `locale` mapping is `keyword`, so the index stores it verbatim —
   * real-table integration tests use `de-DE` / `fr-FR`. Mirrors the
   * `@required locale` member on the Smithy `TranslationSearchResult`;
   * source-string results have no equivalent.
   */
  locale: Scalars['String'];
  localizedText: Scalars['String'];
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  stringId: Scalars['String'];
  variant?: Maybe<Scalars['String']>;
};

export type TranslationSearchResults = {
  __typename?: 'TranslationSearchResults';
  items: Array<TranslationResult>;
  nextToken?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

/** Translation lifecycle status of a string group version. */
export enum TranslationStatus {
  /** Translation was cancelled. */
  Cancelled = 'CANCELLED',
  /** Translation is complete for all target locales. */
  Complete = 'COMPLETE',
  /** Translation failed for one or more locales. */
  Failed = 'FAILED',
  /** Translation work is in progress. */
  InProgress = 'IN_PROGRESS',
}

export type UpdateUserPreferenceInput = {
  preferenceKey: UserPreferenceKey;
  /** Complete replacement list for this key. Each member is a serialized JSON document. */
  values: Array<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  username: Scalars['String'];
};

/** Reserved keys for per-user list-shaped preferences. */
export enum UserPreferenceKey {
  SavedSearches = 'SAVED_SEARCHES',
  SavedTrackFilters = 'SAVED_TRACK_FILTERS',
}

export type UserPreferenceResponse = {
  __typename?: 'UserPreferenceResponse';
  preferenceKey: UserPreferenceKey;
  values: Array<Scalars['String']>;
};

/** Summary of changes between two adjacent versions. */
export type VersionChangeSummary = {
  __typename?: 'VersionChangeSummary';
  addedCount: Scalars['Int'];
  deletedCount: Scalars['Int'];
  editedCount: Scalars['Int'];
};

export type CancelStringGroupTranslationMutationVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  version: Scalars['String'];
}>;

export type CancelStringGroupTranslationMutation = {
  __typename?: 'Mutation';
  cancelStringGroupTranslation: {
    __typename?: 'CancelStringGroupTranslationResponse';
    stringGroupId: string;
    version: number;
  };
};

export type SubmitStringGroupTranslationMutationVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  baseVersion?: InputMaybe<Scalars['String']>;
  added?: InputMaybe<Array<StringInfoInput> | StringInfoInput>;
  edited?: InputMaybe<Array<StringInfoInput> | StringInfoInput>;
  deleted?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  cxIds: Array<Scalars['String']> | Scalars['String'];
  notificationEmail?: InputMaybe<Scalars['String']>;
}>;

export type SubmitStringGroupTranslationMutation = {
  __typename?: 'Mutation';
  submitStringGroupTranslation: {
    __typename?: 'SubmitStringGroupTranslationResponse';
    stringGroupId: string;
    version: number;
  };
};

export type CheckResourcePermissionsQueryVariables = Exact<{
  resourceType: PermissionResourceType;
  resourceId: Scalars['String'];
  permissions: Scalars['String'];
}>;

export type CheckResourcePermissionsQuery = {
  __typename?: 'Query';
  checkResourcePermissions: {
    __typename?: 'ResourcePermissionsResponse';
    permissions: Array<{
      __typename?: 'ResourcePermission';
      permission: string;
      granted: boolean;
    }>;
  };
};

export type DescribeCxFamilyQueryVariables = Exact<{
  cxFamilyId: Scalars['String'];
}>;

export type DescribeCxFamilyQuery = {
  __typename?: 'Query';
  describeCxFamily: {
    __typename?: 'CxFamilyDetailResponse';
    cxFamily: {
      __typename?: 'CxFamilyDetail';
      cxFamilyId: string;
      sourceLocales: Array<string>;
      cxIds: Array<{
        __typename?: 'CxIdDetail';
        cxId: string;
        sourceLocales: Array<string>;
      }>;
    };
  };
};

export type DescribeNamespaceQueryVariables = Exact<{
  namespaceId: Scalars['String'];
}>;

export type DescribeNamespaceQuery = {
  __typename?: 'Query';
  describeNamespace: {
    __typename?: 'NamespaceDetail';
    namespace: {
      __typename?: 'Namespace';
      namespaceId: string;
      bindleResourceId: string;
      defaultCxFamily?: string | null;
      createdAt: number;
      createdBy?: string | null;
      owner?: {
        __typename?: 'ResourceOwner';
        ownerType?: ResourceOwnerType | null;
        ownerId?: string | null;
      } | null;
    };
  };
};

export type DescribeStringQueryVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  stringId: Scalars['String'];
  cxId?: InputMaybe<Scalars['String']>;
  stringGroupVersion?: InputMaybe<Scalars['String']>;
}>;

export type DescribeStringQuery = {
  __typename?: 'Query';
  describeString: {
    __typename?: 'StringDetail';
    stringId: string;
    sourceLocale: string;
    sourceText: string;
    contextNote?: string | null;
    inlineMarkupType?: InlineMarkupType | null;
    messageFormatType?: MessageFormatType | null;
    clientId: string;
    resolvedCxId?: string | null;
    anchorId?: string | null;
    stringGroupVersion: string;
    cxFamilyId: string;
    cxIds: Array<string>;
    updatedAt?: number | null;
    updatedBy?: string | null;
    variants?: Array<{
      __typename?: 'StringVariant';
      cxId: string;
      sourceText: string;
      contextNote?: string | null;
    }> | null;
    translationProgress: {
      __typename?: 'TranslationProgress';
      completedLocales: Array<string>;
      inProgressLocales: Array<string>;
      failedLocales: Array<string>;
      cancelledLocales: Array<string>;
    };
    translations: Array<{
      __typename?: 'Translation';
      locale: string;
      translatedText: string;
      status: string;
    }>;
  };
};

export type DescribeStringGroupQueryVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  stringGroupVersion?: InputMaybe<Scalars['String']>;
}>;

export type DescribeStringGroupQuery = {
  __typename?: 'Query';
  describeStringGroup: {
    __typename?: 'StringGroupDetail';
    stringGroupId: string;
    namespaceId: string;
    clientId: string;
    description?: string | null;
    teamName?: string | null;
    createdOn?: number | null;
    createdBy?: string | null;
    version: number;
    cxFamilyId: string;
    cxIds: Array<string>;
    sourceLocale?: string | null;
    stringCount: number;
    updatedOn?: number | null;
    updatedBy?: string | null;
    translationStatus: TranslationStatus;
    translationProgress: {
      __typename?: 'TranslationProgress';
      completedLocales: Array<string>;
      inProgressLocales: Array<string>;
      failedLocales: Array<string>;
      cancelledLocales: Array<string>;
    };
    strings: Array<{
      __typename?: 'StringInfo';
      stringId: string;
      sourceLocale: string;
      sourceText: string;
      contextNote?: string | null;
      inlineMarkupType?: InlineMarkupType | null;
      messageFormatType?: MessageFormatType | null;
      status?: TranslationStatus | null;
      variants: Array<{
        __typename?: 'StringVariant';
        cxId: string;
        sourceText: string;
        contextNote?: string | null;
      }>;
    }>;
  };
};

export type DescribeStringGroupVersionQueryVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  stringGroupVersion: Scalars['String'];
}>;

export type DescribeStringGroupVersionQuery = {
  __typename?: 'Query';
  describeStringGroup: {
    __typename?: 'StringGroupDetail';
    version: number;
    strings: Array<{
      __typename?: 'StringInfo';
      stringId: string;
      sourceLocale: string;
      sourceText: string;
      contextNote?: string | null;
      inlineMarkupType?: InlineMarkupType | null;
      messageFormatType?: MessageFormatType | null;
      variants: Array<{
        __typename?: 'StringVariant';
        cxId: string;
        sourceText: string;
        contextNote?: string | null;
      }>;
    }>;
  };
};

export type GetPermissionSyncStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetPermissionSyncStatusQuery = {
  __typename?: 'Query';
  getPermissionSyncStatus: {
    __typename?: 'PermissionSyncStatusResponse';
    syncStatus?: PermissionSyncStatus | null;
    hasUnexpiredCachedPermissions: boolean;
    syncStartedAt?: number | null;
  };
};

export type GetUserProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserProfileQuery = {
  __typename?: 'Query';
  getUserProfile: { __typename?: 'User'; username: string };
};

export type ListActiveTranslationJobsQueryVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupId?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;

export type ListActiveTranslationJobsQuery = {
  __typename?: 'Query';
  listActiveTranslationJobs: {
    __typename?: 'ActiveTranslationJobsConnection';
    nextToken?: string | null;
    items: Array<{
      __typename?: 'ActiveTranslationJob';
      namespaceId: string;
      stringGroupId: string;
      stringGroupVersion: string;
      trackingId: string;
      clientId: string;
      translationStatus: TranslationStatus;
      sentForTranslationDate: string;
      dueDate: string;
    }>;
  };
};

export type ListAllLocalesQueryVariables = Exact<{
  localeType: LocaleType;
}>;

export type ListAllLocalesQuery = {
  __typename?: 'Query';
  listAllLocales: { __typename?: 'AllLocalesResponse'; locales: Array<string> };
};

export type ListCxFamiliesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;

export type ListCxFamiliesQuery = {
  __typename?: 'Query';
  listCxFamilies: {
    __typename?: 'CxFamiliesList';
    nextToken?: string | null;
    cxFamilies: Array<{
      __typename?: 'CxFamilySummary';
      cxFamilyId: string;
      cxIds: Array<string>;
    }>;
  };
};

export type ListNamespacesQueryVariables = Exact<{
  namespaceIdPrefix?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
}>;

export type ListNamespacesQuery = {
  __typename?: 'Query';
  listNamespaces: {
    __typename?: 'NamespaceList';
    nextToken?: string | null;
    namespaces: Array<{ __typename?: 'NamespaceItem'; namespaceId: string }>;
  };
};

export type ListStringGroupVersionsQueryVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  sortOrder?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
  maxResults?: InputMaybe<Scalars['Int']>;
}>;

export type ListStringGroupVersionsQuery = {
  __typename?: 'Query';
  listStringGroupVersions: {
    __typename?: 'ListStringGroupVersionsResponse';
    nextToken?: string | null;
    versions: Array<{
      __typename?: 'StringGroupVersionSummary';
      version: number;
      translationStatus: TranslationStatus;
      stringCount: number;
      updatedOn?: number | null;
      updatedBy?: string | null;
      changeSummary?: {
        __typename?: 'VersionChangeSummary';
        addedCount: number;
        editedCount: number;
        deletedCount: number;
      } | null;
    }>;
  };
};

export type ListStringGroupsQueryVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupIdPrefix?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  includeLatestSnapshot?: InputMaybe<Scalars['Boolean']>;
}>;

export type ListStringGroupsQuery = {
  __typename?: 'Query';
  listStringGroups: {
    __typename?: 'StringGroupsList';
    nextToken?: string | null;
    stringGroups: Array<{
      __typename?: 'StringGroupItem';
      stringGroupId: string;
      clientId?: string | null;
      createdBy?: string | null;
      createdAt?: number | null;
      teamName?: string | null;
      latestVersion?: {
        __typename?: 'StringGroupVersionMetadata';
        cxFamilyId: string;
        cxIds: Array<string>;
        sourceLocale?: string | null;
        stringCount: number;
        updatedAt?: number | null;
        updatedBy?: string | null;
      } | null;
    }>;
  };
};

export type ListStringsQueryVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupId: Scalars['String'];
  stringGroupVersion?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
  maxResults?: InputMaybe<Scalars['Int']>;
}>;

export type ListStringsQuery = {
  __typename?: 'Query';
  listStrings: {
    __typename?: 'ListStringsResponse';
    nextToken?: string | null;
    strings: Array<{
      __typename?: 'StringInfo';
      stringId: string;
      sourceLocale: string;
      sourceText: string;
      contextNote?: string | null;
      inlineMarkupType?: InlineMarkupType | null;
      messageFormatType?: MessageFormatType | null;
      status?: TranslationStatus | null;
      variants: Array<{
        __typename?: 'StringVariant';
        cxId: string;
        sourceText: string;
        contextNote?: string | null;
      }>;
    }>;
  };
};

export type ListTranslationJobHistoryQueryVariables = Exact<{
  namespaceId: Scalars['String'];
  stringGroupId?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;

export type ListTranslationJobHistoryQuery = {
  __typename?: 'Query';
  listTranslationJobHistory: {
    __typename?: 'HistoricalTranslationJobsConnection';
    nextToken?: string | null;
    items: Array<{
      __typename?: 'HistoricalTranslationJob';
      namespaceId: string;
      stringGroupId: string;
      stringGroupVersion: string;
      trackingId: string;
      clientId: string;
      translationStatus: TranslationStatus;
      sentForTranslationDate: string;
      deliveredOnDate?: string | null;
    }>;
  };
};

export type SearchSourceStringsQueryVariables = Exact<{
  input: SearchSourceStringsInput;
}>;

export type SearchSourceStringsQuery = {
  __typename?: 'Query';
  searchSourceStrings: {
    __typename?: 'SourceStringSearchResults';
    nextToken?: string | null;
    totalCount: number;
    items: Array<{
      __typename?: 'SourceStringResult';
      stringId: string;
      namespaceId: string;
      stringGroupId: string;
      groupVersion: string;
      variant?: string | null;
      status: TranslationStatus;
      sourceContent: string;
    }>;
  };
};

export type SearchTranslationsQueryVariables = Exact<{
  input: SearchTranslationsInput;
}>;

export type SearchTranslationsQuery = {
  __typename?: 'Query';
  searchTranslations: {
    __typename?: 'TranslationSearchResults';
    nextToken?: string | null;
    totalCount: number;
    items: Array<{
      __typename?: 'TranslationResult';
      stringId: string;
      namespaceId: string;
      stringGroupId: string;
      groupVersion: string;
      variant?: string | null;
      localizedText: string;
      locale: string;
    }>;
  };
};

export const CancelStringGroupTranslationDocument = gql`
  mutation CancelStringGroupTranslation(
    $namespaceId: String!
    $stringGroupId: String!
    $version: String!
  ) {
    cancelStringGroupTranslation(
      namespaceId: $namespaceId
      stringGroupId: $stringGroupId
      version: $version
    ) {
      stringGroupId
      version
    }
  }
`;
export type CancelStringGroupTranslationMutationFn = Apollo.MutationFunction<
  CancelStringGroupTranslationMutation,
  CancelStringGroupTranslationMutationVariables
>;

/**
 * __useCancelStringGroupTranslationMutation__
 *
 * To run a mutation, you first call `useCancelStringGroupTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelStringGroupTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelStringGroupTranslationMutation, { data, loading, error }] = useCancelStringGroupTranslationMutation({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupId: // value for 'stringGroupId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useCancelStringGroupTranslationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelStringGroupTranslationMutation,
    CancelStringGroupTranslationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelStringGroupTranslationMutation,
    CancelStringGroupTranslationMutationVariables
  >(CancelStringGroupTranslationDocument, options);
}
export type CancelStringGroupTranslationMutationHookResult = ReturnType<
  typeof useCancelStringGroupTranslationMutation
>;
export type CancelStringGroupTranslationMutationResult =
  Apollo.MutationResult<CancelStringGroupTranslationMutation>;
export type CancelStringGroupTranslationMutationOptions =
  Apollo.BaseMutationOptions<
    CancelStringGroupTranslationMutation,
    CancelStringGroupTranslationMutationVariables
  >;
export const SubmitStringGroupTranslationDocument = gql`
  mutation SubmitStringGroupTranslation(
    $namespaceId: String!
    $stringGroupId: String!
    $baseVersion: String
    $added: [StringInfoInput!]
    $edited: [StringInfoInput!]
    $deleted: [String!]
    $cxIds: [String!]!
    $notificationEmail: String
  ) {
    submitStringGroupTranslation(
      namespaceId: $namespaceId
      stringGroupId: $stringGroupId
      baseVersion: $baseVersion
      added: $added
      edited: $edited
      deleted: $deleted
      cxIds: $cxIds
      notificationEmail: $notificationEmail
    ) {
      stringGroupId
      version
    }
  }
`;
export type SubmitStringGroupTranslationMutationFn = Apollo.MutationFunction<
  SubmitStringGroupTranslationMutation,
  SubmitStringGroupTranslationMutationVariables
>;

/**
 * __useSubmitStringGroupTranslationMutation__
 *
 * To run a mutation, you first call `useSubmitStringGroupTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitStringGroupTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitStringGroupTranslationMutation, { data, loading, error }] = useSubmitStringGroupTranslationMutation({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupId: // value for 'stringGroupId'
 *      baseVersion: // value for 'baseVersion'
 *      added: // value for 'added'
 *      edited: // value for 'edited'
 *      deleted: // value for 'deleted'
 *      cxIds: // value for 'cxIds'
 *      notificationEmail: // value for 'notificationEmail'
 *   },
 * });
 */
export function useSubmitStringGroupTranslationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitStringGroupTranslationMutation,
    SubmitStringGroupTranslationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitStringGroupTranslationMutation,
    SubmitStringGroupTranslationMutationVariables
  >(SubmitStringGroupTranslationDocument, options);
}
export type SubmitStringGroupTranslationMutationHookResult = ReturnType<
  typeof useSubmitStringGroupTranslationMutation
>;
export type SubmitStringGroupTranslationMutationResult =
  Apollo.MutationResult<SubmitStringGroupTranslationMutation>;
export type SubmitStringGroupTranslationMutationOptions =
  Apollo.BaseMutationOptions<
    SubmitStringGroupTranslationMutation,
    SubmitStringGroupTranslationMutationVariables
  >;
export const CheckResourcePermissionsDocument = gql`
  query CheckResourcePermissions(
    $resourceType: PermissionResourceType!
    $resourceId: String!
    $permissions: String!
  ) {
    checkResourcePermissions(
      resourceType: $resourceType
      resourceId: $resourceId
      permissions: $permissions
    ) {
      permissions {
        permission
        granted
      }
    }
  }
`;

/**
 * __useCheckResourcePermissionsQuery__
 *
 * To run a query within a React component, call `useCheckResourcePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckResourcePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckResourcePermissionsQuery({
 *   variables: {
 *      resourceType: // value for 'resourceType'
 *      resourceId: // value for 'resourceId'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useCheckResourcePermissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckResourcePermissionsQuery,
    CheckResourcePermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckResourcePermissionsQuery,
    CheckResourcePermissionsQueryVariables
  >(CheckResourcePermissionsDocument, options);
}
export function useCheckResourcePermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckResourcePermissionsQuery,
    CheckResourcePermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckResourcePermissionsQuery,
    CheckResourcePermissionsQueryVariables
  >(CheckResourcePermissionsDocument, options);
}
export type CheckResourcePermissionsQueryHookResult = ReturnType<
  typeof useCheckResourcePermissionsQuery
>;
export type CheckResourcePermissionsLazyQueryHookResult = ReturnType<
  typeof useCheckResourcePermissionsLazyQuery
>;
export type CheckResourcePermissionsQueryResult = Apollo.QueryResult<
  CheckResourcePermissionsQuery,
  CheckResourcePermissionsQueryVariables
>;
export const DescribeCxFamilyDocument = gql`
  query DescribeCxFamily($cxFamilyId: String!) {
    describeCxFamily(cxFamilyId: $cxFamilyId) {
      cxFamily {
        cxFamilyId
        cxIds {
          cxId
          sourceLocales
        }
        sourceLocales
      }
    }
  }
`;

/**
 * __useDescribeCxFamilyQuery__
 *
 * To run a query within a React component, call `useDescribeCxFamilyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDescribeCxFamilyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDescribeCxFamilyQuery({
 *   variables: {
 *      cxFamilyId: // value for 'cxFamilyId'
 *   },
 * });
 */
export function useDescribeCxFamilyQuery(
  baseOptions: Apollo.QueryHookOptions<
    DescribeCxFamilyQuery,
    DescribeCxFamilyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DescribeCxFamilyQuery, DescribeCxFamilyQueryVariables>(
    DescribeCxFamilyDocument,
    options,
  );
}
export function useDescribeCxFamilyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DescribeCxFamilyQuery,
    DescribeCxFamilyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DescribeCxFamilyQuery,
    DescribeCxFamilyQueryVariables
  >(DescribeCxFamilyDocument, options);
}
export type DescribeCxFamilyQueryHookResult = ReturnType<
  typeof useDescribeCxFamilyQuery
>;
export type DescribeCxFamilyLazyQueryHookResult = ReturnType<
  typeof useDescribeCxFamilyLazyQuery
>;
export type DescribeCxFamilyQueryResult = Apollo.QueryResult<
  DescribeCxFamilyQuery,
  DescribeCxFamilyQueryVariables
>;
export const DescribeNamespaceDocument = gql`
  query DescribeNamespace($namespaceId: String!) {
    describeNamespace(namespaceId: $namespaceId) {
      namespace {
        namespaceId
        bindleResourceId
        defaultCxFamily
        createdAt
        createdBy
        owner {
          ownerType
          ownerId
        }
      }
    }
  }
`;

/**
 * __useDescribeNamespaceQuery__
 *
 * To run a query within a React component, call `useDescribeNamespaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDescribeNamespaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDescribeNamespaceQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *   },
 * });
 */
export function useDescribeNamespaceQuery(
  baseOptions: Apollo.QueryHookOptions<
    DescribeNamespaceQuery,
    DescribeNamespaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DescribeNamespaceQuery,
    DescribeNamespaceQueryVariables
  >(DescribeNamespaceDocument, options);
}
export function useDescribeNamespaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DescribeNamespaceQuery,
    DescribeNamespaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DescribeNamespaceQuery,
    DescribeNamespaceQueryVariables
  >(DescribeNamespaceDocument, options);
}
export type DescribeNamespaceQueryHookResult = ReturnType<
  typeof useDescribeNamespaceQuery
>;
export type DescribeNamespaceLazyQueryHookResult = ReturnType<
  typeof useDescribeNamespaceLazyQuery
>;
export type DescribeNamespaceQueryResult = Apollo.QueryResult<
  DescribeNamespaceQuery,
  DescribeNamespaceQueryVariables
>;
export const DescribeStringDocument = gql`
  query DescribeString(
    $namespaceId: String!
    $stringGroupId: String!
    $stringId: String!
    $cxId: String
    $stringGroupVersion: String
  ) {
    describeString(
      namespaceId: $namespaceId
      stringGroupId: $stringGroupId
      stringId: $stringId
      cxId: $cxId
      stringGroupVersion: $stringGroupVersion
    ) {
      stringId
      sourceLocale
      sourceText
      contextNote
      inlineMarkupType
      messageFormatType
      clientId
      variants {
        cxId
        sourceText
        contextNote
      }
      resolvedCxId
      anchorId
      stringGroupVersion
      cxFamilyId
      cxIds
      translationProgress {
        completedLocales
        inProgressLocales
        failedLocales
        cancelledLocales
      }
      translations {
        locale
        translatedText
        status
      }
      updatedAt
      updatedBy
    }
  }
`;

/**
 * __useDescribeStringQuery__
 *
 * To run a query within a React component, call `useDescribeStringQuery` and pass it any options that fit your needs.
 * When your component renders, `useDescribeStringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDescribeStringQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupId: // value for 'stringGroupId'
 *      stringId: // value for 'stringId'
 *      cxId: // value for 'cxId'
 *      stringGroupVersion: // value for 'stringGroupVersion'
 *   },
 * });
 */
export function useDescribeStringQuery(
  baseOptions: Apollo.QueryHookOptions<
    DescribeStringQuery,
    DescribeStringQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DescribeStringQuery, DescribeStringQueryVariables>(
    DescribeStringDocument,
    options,
  );
}
export function useDescribeStringLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DescribeStringQuery,
    DescribeStringQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DescribeStringQuery, DescribeStringQueryVariables>(
    DescribeStringDocument,
    options,
  );
}
export type DescribeStringQueryHookResult = ReturnType<
  typeof useDescribeStringQuery
>;
export type DescribeStringLazyQueryHookResult = ReturnType<
  typeof useDescribeStringLazyQuery
>;
export type DescribeStringQueryResult = Apollo.QueryResult<
  DescribeStringQuery,
  DescribeStringQueryVariables
>;
export const DescribeStringGroupDocument = gql`
  query DescribeStringGroup(
    $namespaceId: String!
    $stringGroupId: String!
    $stringGroupVersion: String
  ) {
    describeStringGroup(
      namespaceId: $namespaceId
      stringGroupId: $stringGroupId
      stringGroupVersion: $stringGroupVersion
      includeStrings: true
    ) {
      stringGroupId
      namespaceId
      clientId
      description
      teamName
      createdOn
      createdBy
      version
      cxFamilyId
      cxIds
      sourceLocale
      stringCount
      updatedOn
      updatedBy
      translationStatus
      translationProgress {
        completedLocales
        inProgressLocales
        failedLocales
        cancelledLocales
      }
      strings {
        stringId
        sourceLocale
        sourceText
        contextNote
        inlineMarkupType
        messageFormatType
        status
        variants {
          cxId
          sourceText
          contextNote
        }
      }
    }
  }
`;

/**
 * __useDescribeStringGroupQuery__
 *
 * To run a query within a React component, call `useDescribeStringGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useDescribeStringGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDescribeStringGroupQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupId: // value for 'stringGroupId'
 *      stringGroupVersion: // value for 'stringGroupVersion'
 *   },
 * });
 */
export function useDescribeStringGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    DescribeStringGroupQuery,
    DescribeStringGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DescribeStringGroupQuery,
    DescribeStringGroupQueryVariables
  >(DescribeStringGroupDocument, options);
}
export function useDescribeStringGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DescribeStringGroupQuery,
    DescribeStringGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DescribeStringGroupQuery,
    DescribeStringGroupQueryVariables
  >(DescribeStringGroupDocument, options);
}
export type DescribeStringGroupQueryHookResult = ReturnType<
  typeof useDescribeStringGroupQuery
>;
export type DescribeStringGroupLazyQueryHookResult = ReturnType<
  typeof useDescribeStringGroupLazyQuery
>;
export type DescribeStringGroupQueryResult = Apollo.QueryResult<
  DescribeStringGroupQuery,
  DescribeStringGroupQueryVariables
>;
export const DescribeStringGroupVersionDocument = gql`
  query DescribeStringGroupVersion(
    $namespaceId: String!
    $stringGroupId: String!
    $stringGroupVersion: String!
  ) {
    describeStringGroup(
      namespaceId: $namespaceId
      stringGroupId: $stringGroupId
      stringGroupVersion: $stringGroupVersion
      includeStrings: true
    ) {
      version
      strings {
        stringId
        sourceLocale
        sourceText
        contextNote
        inlineMarkupType
        messageFormatType
        variants {
          cxId
          sourceText
          contextNote
        }
      }
    }
  }
`;

/**
 * __useDescribeStringGroupVersionQuery__
 *
 * To run a query within a React component, call `useDescribeStringGroupVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDescribeStringGroupVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDescribeStringGroupVersionQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupId: // value for 'stringGroupId'
 *      stringGroupVersion: // value for 'stringGroupVersion'
 *   },
 * });
 */
export function useDescribeStringGroupVersionQuery(
  baseOptions: Apollo.QueryHookOptions<
    DescribeStringGroupVersionQuery,
    DescribeStringGroupVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DescribeStringGroupVersionQuery,
    DescribeStringGroupVersionQueryVariables
  >(DescribeStringGroupVersionDocument, options);
}
export function useDescribeStringGroupVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DescribeStringGroupVersionQuery,
    DescribeStringGroupVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DescribeStringGroupVersionQuery,
    DescribeStringGroupVersionQueryVariables
  >(DescribeStringGroupVersionDocument, options);
}
export type DescribeStringGroupVersionQueryHookResult = ReturnType<
  typeof useDescribeStringGroupVersionQuery
>;
export type DescribeStringGroupVersionLazyQueryHookResult = ReturnType<
  typeof useDescribeStringGroupVersionLazyQuery
>;
export type DescribeStringGroupVersionQueryResult = Apollo.QueryResult<
  DescribeStringGroupVersionQuery,
  DescribeStringGroupVersionQueryVariables
>;
export const GetPermissionSyncStatusDocument = gql`
  query GetPermissionSyncStatus {
    getPermissionSyncStatus {
      syncStatus
      hasUnexpiredCachedPermissions
      syncStartedAt
    }
  }
`;

/**
 * __useGetPermissionSyncStatusQuery__
 *
 * To run a query within a React component, call `useGetPermissionSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionSyncStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionSyncStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPermissionSyncStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPermissionSyncStatusQuery,
    GetPermissionSyncStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPermissionSyncStatusQuery,
    GetPermissionSyncStatusQueryVariables
  >(GetPermissionSyncStatusDocument, options);
}
export function useGetPermissionSyncStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPermissionSyncStatusQuery,
    GetPermissionSyncStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPermissionSyncStatusQuery,
    GetPermissionSyncStatusQueryVariables
  >(GetPermissionSyncStatusDocument, options);
}
export type GetPermissionSyncStatusQueryHookResult = ReturnType<
  typeof useGetPermissionSyncStatusQuery
>;
export type GetPermissionSyncStatusLazyQueryHookResult = ReturnType<
  typeof useGetPermissionSyncStatusLazyQuery
>;
export type GetPermissionSyncStatusQueryResult = Apollo.QueryResult<
  GetPermissionSyncStatusQuery,
  GetPermissionSyncStatusQueryVariables
>;
export const GetUserProfileDocument = gql`
  query GetUserProfile {
    getUserProfile {
      username
    }
  }
`;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserProfileQuery,
    GetUserProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(
    GetUserProfileDocument,
    options,
  );
}
export function useGetUserProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserProfileQuery,
    GetUserProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(
    GetUserProfileDocument,
    options,
  );
}
export type GetUserProfileQueryHookResult = ReturnType<
  typeof useGetUserProfileQuery
>;
export type GetUserProfileLazyQueryHookResult = ReturnType<
  typeof useGetUserProfileLazyQuery
>;
export type GetUserProfileQueryResult = Apollo.QueryResult<
  GetUserProfileQuery,
  GetUserProfileQueryVariables
>;
export const ListActiveTranslationJobsDocument = gql`
  query ListActiveTranslationJobs(
    $namespaceId: String!
    $stringGroupId: String
    $dateFrom: String
    $dateTo: String
    $pageSize: Int
    $nextToken: String
  ) {
    listActiveTranslationJobs(
      namespaceId: $namespaceId
      stringGroupId: $stringGroupId
      dateFrom: $dateFrom
      dateTo: $dateTo
      pageSize: $pageSize
      nextToken: $nextToken
    ) {
      items {
        namespaceId
        stringGroupId
        stringGroupVersion
        trackingId
        clientId
        translationStatus
        sentForTranslationDate
        dueDate
      }
      nextToken
    }
  }
`;

/**
 * __useListActiveTranslationJobsQuery__
 *
 * To run a query within a React component, call `useListActiveTranslationJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActiveTranslationJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActiveTranslationJobsQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupId: // value for 'stringGroupId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      pageSize: // value for 'pageSize'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListActiveTranslationJobsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListActiveTranslationJobsQuery,
    ListActiveTranslationJobsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListActiveTranslationJobsQuery,
    ListActiveTranslationJobsQueryVariables
  >(ListActiveTranslationJobsDocument, options);
}
export function useListActiveTranslationJobsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListActiveTranslationJobsQuery,
    ListActiveTranslationJobsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListActiveTranslationJobsQuery,
    ListActiveTranslationJobsQueryVariables
  >(ListActiveTranslationJobsDocument, options);
}
export type ListActiveTranslationJobsQueryHookResult = ReturnType<
  typeof useListActiveTranslationJobsQuery
>;
export type ListActiveTranslationJobsLazyQueryHookResult = ReturnType<
  typeof useListActiveTranslationJobsLazyQuery
>;
export type ListActiveTranslationJobsQueryResult = Apollo.QueryResult<
  ListActiveTranslationJobsQuery,
  ListActiveTranslationJobsQueryVariables
>;
export const ListAllLocalesDocument = gql`
  query ListAllLocales($localeType: LocaleType!) {
    listAllLocales(localeType: $localeType) {
      locales
    }
  }
`;

/**
 * __useListAllLocalesQuery__
 *
 * To run a query within a React component, call `useListAllLocalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllLocalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllLocalesQuery({
 *   variables: {
 *      localeType: // value for 'localeType'
 *   },
 * });
 */
export function useListAllLocalesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListAllLocalesQuery,
    ListAllLocalesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAllLocalesQuery, ListAllLocalesQueryVariables>(
    ListAllLocalesDocument,
    options,
  );
}
export function useListAllLocalesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListAllLocalesQuery,
    ListAllLocalesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListAllLocalesQuery, ListAllLocalesQueryVariables>(
    ListAllLocalesDocument,
    options,
  );
}
export type ListAllLocalesQueryHookResult = ReturnType<
  typeof useListAllLocalesQuery
>;
export type ListAllLocalesLazyQueryHookResult = ReturnType<
  typeof useListAllLocalesLazyQuery
>;
export type ListAllLocalesQueryResult = Apollo.QueryResult<
  ListAllLocalesQuery,
  ListAllLocalesQueryVariables
>;
export const ListCxFamiliesDocument = gql`
  query ListCxFamilies($pageSize: Int, $nextToken: String) {
    listCxFamilies(pageSize: $pageSize, nextToken: $nextToken) {
      cxFamilies {
        cxFamilyId
        cxIds
      }
      nextToken
    }
  }
`;

/**
 * __useListCxFamiliesQuery__
 *
 * To run a query within a React component, call `useListCxFamiliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCxFamiliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCxFamiliesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListCxFamiliesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListCxFamiliesQuery,
    ListCxFamiliesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCxFamiliesQuery, ListCxFamiliesQueryVariables>(
    ListCxFamiliesDocument,
    options,
  );
}
export function useListCxFamiliesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListCxFamiliesQuery,
    ListCxFamiliesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCxFamiliesQuery, ListCxFamiliesQueryVariables>(
    ListCxFamiliesDocument,
    options,
  );
}
export type ListCxFamiliesQueryHookResult = ReturnType<
  typeof useListCxFamiliesQuery
>;
export type ListCxFamiliesLazyQueryHookResult = ReturnType<
  typeof useListCxFamiliesLazyQuery
>;
export type ListCxFamiliesQueryResult = Apollo.QueryResult<
  ListCxFamiliesQuery,
  ListCxFamiliesQueryVariables
>;
export const ListNamespacesDocument = gql`
  query ListNamespaces(
    $namespaceIdPrefix: String
    $pageSize: Int
    $nextToken: String
    $sortOrder: String
  ) {
    listNamespaces(
      namespaceIdPrefix: $namespaceIdPrefix
      pageSize: $pageSize
      nextToken: $nextToken
      sortOrder: $sortOrder
    ) {
      namespaces {
        namespaceId
      }
      nextToken
    }
  }
`;

/**
 * __useListNamespacesQuery__
 *
 * To run a query within a React component, call `useListNamespacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNamespacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNamespacesQuery({
 *   variables: {
 *      namespaceIdPrefix: // value for 'namespaceIdPrefix'
 *      pageSize: // value for 'pageSize'
 *      nextToken: // value for 'nextToken'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useListNamespacesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListNamespacesQuery,
    ListNamespacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListNamespacesQuery, ListNamespacesQueryVariables>(
    ListNamespacesDocument,
    options,
  );
}
export function useListNamespacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListNamespacesQuery,
    ListNamespacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListNamespacesQuery, ListNamespacesQueryVariables>(
    ListNamespacesDocument,
    options,
  );
}
export type ListNamespacesQueryHookResult = ReturnType<
  typeof useListNamespacesQuery
>;
export type ListNamespacesLazyQueryHookResult = ReturnType<
  typeof useListNamespacesLazyQuery
>;
export type ListNamespacesQueryResult = Apollo.QueryResult<
  ListNamespacesQuery,
  ListNamespacesQueryVariables
>;
export const ListStringGroupVersionsDocument = gql`
  query ListStringGroupVersions(
    $namespaceId: String!
    $stringGroupId: String!
    $sortOrder: String
    $nextToken: String
    $maxResults: Int
  ) {
    listStringGroupVersions(
      namespaceId: $namespaceId
      stringGroupId: $stringGroupId
      sortOrder: $sortOrder
      nextToken: $nextToken
      maxResults: $maxResults
    ) {
      versions {
        version
        translationStatus
        stringCount
        updatedOn
        updatedBy
        changeSummary {
          addedCount
          editedCount
          deletedCount
        }
      }
      nextToken
    }
  }
`;

/**
 * __useListStringGroupVersionsQuery__
 *
 * To run a query within a React component, call `useListStringGroupVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStringGroupVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStringGroupVersionsQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupId: // value for 'stringGroupId'
 *      sortOrder: // value for 'sortOrder'
 *      nextToken: // value for 'nextToken'
 *      maxResults: // value for 'maxResults'
 *   },
 * });
 */
export function useListStringGroupVersionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListStringGroupVersionsQuery,
    ListStringGroupVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListStringGroupVersionsQuery,
    ListStringGroupVersionsQueryVariables
  >(ListStringGroupVersionsDocument, options);
}
export function useListStringGroupVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListStringGroupVersionsQuery,
    ListStringGroupVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListStringGroupVersionsQuery,
    ListStringGroupVersionsQueryVariables
  >(ListStringGroupVersionsDocument, options);
}
export type ListStringGroupVersionsQueryHookResult = ReturnType<
  typeof useListStringGroupVersionsQuery
>;
export type ListStringGroupVersionsLazyQueryHookResult = ReturnType<
  typeof useListStringGroupVersionsLazyQuery
>;
export type ListStringGroupVersionsQueryResult = Apollo.QueryResult<
  ListStringGroupVersionsQuery,
  ListStringGroupVersionsQueryVariables
>;
export const ListStringGroupsDocument = gql`
  query ListStringGroups(
    $namespaceId: String!
    $stringGroupIdPrefix: String
    $pageSize: Int
    $nextToken: String
    $includeLatestSnapshot: Boolean
  ) {
    listStringGroups(
      namespaceId: $namespaceId
      stringGroupIdPrefix: $stringGroupIdPrefix
      pageSize: $pageSize
      nextToken: $nextToken
      includeLatestSnapshot: $includeLatestSnapshot
    ) {
      stringGroups {
        stringGroupId
        clientId
        createdBy
        createdAt
        teamName
        latestVersion {
          cxFamilyId
          cxIds
          sourceLocale
          stringCount
          updatedAt
          updatedBy
        }
      }
      nextToken
    }
  }
`;

/**
 * __useListStringGroupsQuery__
 *
 * To run a query within a React component, call `useListStringGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStringGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStringGroupsQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupIdPrefix: // value for 'stringGroupIdPrefix'
 *      pageSize: // value for 'pageSize'
 *      nextToken: // value for 'nextToken'
 *      includeLatestSnapshot: // value for 'includeLatestSnapshot'
 *   },
 * });
 */
export function useListStringGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListStringGroupsQuery,
    ListStringGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListStringGroupsQuery, ListStringGroupsQueryVariables>(
    ListStringGroupsDocument,
    options,
  );
}
export function useListStringGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListStringGroupsQuery,
    ListStringGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListStringGroupsQuery,
    ListStringGroupsQueryVariables
  >(ListStringGroupsDocument, options);
}
export type ListStringGroupsQueryHookResult = ReturnType<
  typeof useListStringGroupsQuery
>;
export type ListStringGroupsLazyQueryHookResult = ReturnType<
  typeof useListStringGroupsLazyQuery
>;
export type ListStringGroupsQueryResult = Apollo.QueryResult<
  ListStringGroupsQuery,
  ListStringGroupsQueryVariables
>;
export const ListStringsDocument = gql`
  query ListStrings(
    $namespaceId: String!
    $stringGroupId: String!
    $stringGroupVersion: String
    $nextToken: String
    $maxResults: Int
  ) {
    listStrings(
      namespaceId: $namespaceId
      stringGroupId: $stringGroupId
      stringGroupVersion: $stringGroupVersion
      nextToken: $nextToken
      maxResults: $maxResults
    ) {
      strings {
        stringId
        sourceLocale
        sourceText
        contextNote
        inlineMarkupType
        messageFormatType
        status
        variants {
          cxId
          sourceText
          contextNote
        }
      }
      nextToken
    }
  }
`;

/**
 * __useListStringsQuery__
 *
 * To run a query within a React component, call `useListStringsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStringsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStringsQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupId: // value for 'stringGroupId'
 *      stringGroupVersion: // value for 'stringGroupVersion'
 *      nextToken: // value for 'nextToken'
 *      maxResults: // value for 'maxResults'
 *   },
 * });
 */
export function useListStringsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListStringsQuery,
    ListStringsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListStringsQuery, ListStringsQueryVariables>(
    ListStringsDocument,
    options,
  );
}
export function useListStringsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListStringsQuery,
    ListStringsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListStringsQuery, ListStringsQueryVariables>(
    ListStringsDocument,
    options,
  );
}
export type ListStringsQueryHookResult = ReturnType<typeof useListStringsQuery>;
export type ListStringsLazyQueryHookResult = ReturnType<
  typeof useListStringsLazyQuery
>;
export type ListStringsQueryResult = Apollo.QueryResult<
  ListStringsQuery,
  ListStringsQueryVariables
>;
export const ListTranslationJobHistoryDocument = gql`
  query ListTranslationJobHistory(
    $namespaceId: String!
    $stringGroupId: String
    $dateFrom: String
    $dateTo: String
    $pageSize: Int
    $nextToken: String
  ) {
    listTranslationJobHistory(
      namespaceId: $namespaceId
      stringGroupId: $stringGroupId
      dateFrom: $dateFrom
      dateTo: $dateTo
      pageSize: $pageSize
      nextToken: $nextToken
    ) {
      items {
        namespaceId
        stringGroupId
        stringGroupVersion
        trackingId
        clientId
        translationStatus
        sentForTranslationDate
        deliveredOnDate
      }
      nextToken
    }
  }
`;

/**
 * __useListTranslationJobHistoryQuery__
 *
 * To run a query within a React component, call `useListTranslationJobHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTranslationJobHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTranslationJobHistoryQuery({
 *   variables: {
 *      namespaceId: // value for 'namespaceId'
 *      stringGroupId: // value for 'stringGroupId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      pageSize: // value for 'pageSize'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListTranslationJobHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListTranslationJobHistoryQuery,
    ListTranslationJobHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListTranslationJobHistoryQuery,
    ListTranslationJobHistoryQueryVariables
  >(ListTranslationJobHistoryDocument, options);
}
export function useListTranslationJobHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTranslationJobHistoryQuery,
    ListTranslationJobHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListTranslationJobHistoryQuery,
    ListTranslationJobHistoryQueryVariables
  >(ListTranslationJobHistoryDocument, options);
}
export type ListTranslationJobHistoryQueryHookResult = ReturnType<
  typeof useListTranslationJobHistoryQuery
>;
export type ListTranslationJobHistoryLazyQueryHookResult = ReturnType<
  typeof useListTranslationJobHistoryLazyQuery
>;
export type ListTranslationJobHistoryQueryResult = Apollo.QueryResult<
  ListTranslationJobHistoryQuery,
  ListTranslationJobHistoryQueryVariables
>;
export const SearchSourceStringsDocument = gql`
  query SearchSourceStrings($input: SearchSourceStringsInput!) {
    searchSourceStrings(input: $input) {
      items {
        stringId
        namespaceId
        stringGroupId
        groupVersion
        variant
        status
        sourceContent
      }
      nextToken
      totalCount
    }
  }
`;

/**
 * __useSearchSourceStringsQuery__
 *
 * To run a query within a React component, call `useSearchSourceStringsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSourceStringsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSourceStringsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchSourceStringsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchSourceStringsQuery,
    SearchSourceStringsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchSourceStringsQuery,
    SearchSourceStringsQueryVariables
  >(SearchSourceStringsDocument, options);
}
export function useSearchSourceStringsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchSourceStringsQuery,
    SearchSourceStringsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchSourceStringsQuery,
    SearchSourceStringsQueryVariables
  >(SearchSourceStringsDocument, options);
}
export type SearchSourceStringsQueryHookResult = ReturnType<
  typeof useSearchSourceStringsQuery
>;
export type SearchSourceStringsLazyQueryHookResult = ReturnType<
  typeof useSearchSourceStringsLazyQuery
>;
export type SearchSourceStringsQueryResult = Apollo.QueryResult<
  SearchSourceStringsQuery,
  SearchSourceStringsQueryVariables
>;
export const SearchTranslationsDocument = gql`
  query SearchTranslations($input: SearchTranslationsInput!) {
    searchTranslations(input: $input) {
      items {
        stringId
        namespaceId
        stringGroupId
        groupVersion
        variant
        localizedText
        locale
      }
      nextToken
      totalCount
    }
  }
`;

/**
 * __useSearchTranslationsQuery__
 *
 * To run a query within a React component, call `useSearchTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTranslationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchTranslationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchTranslationsQuery,
    SearchTranslationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchTranslationsQuery,
    SearchTranslationsQueryVariables
  >(SearchTranslationsDocument, options);
}
export function useSearchTranslationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchTranslationsQuery,
    SearchTranslationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchTranslationsQuery,
    SearchTranslationsQueryVariables
  >(SearchTranslationsDocument, options);
}
export type SearchTranslationsQueryHookResult = ReturnType<
  typeof useSearchTranslationsQuery
>;
export type SearchTranslationsLazyQueryHookResult = ReturnType<
  typeof useSearchTranslationsLazyQuery
>;
export type SearchTranslationsQueryResult = Apollo.QueryResult<
  SearchTranslationsQuery,
  SearchTranslationsQueryVariables
>;

export type GetUserPreferenceQueryVariables = Exact<{
  preferenceKey: UserPreferenceKey;
}>;

export type GetUserPreferenceQuery = { __typename?: 'Query', getUserPreference: { __typename?: 'UserPreferenceResponse', preferenceKey: UserPreferenceKey, values: Array<string> } };

export type UpdateUserPreferenceMutationVariables = Exact<{
  input: UpdateUserPreferenceInput;
}>;

export type UpdateUserPreferenceMutation = { __typename?: 'Mutation', updateUserPreference: { __typename?: 'UserPreferenceResponse', preferenceKey: UserPreferenceKey, values: Array<string> } };

export const GetUserPreferenceDocument = gql`
    query GetUserPreference($preferenceKey: UserPreferenceKey!) {
  getUserPreference(preferenceKey: $preferenceKey) {
    preferenceKey
    values
  }
}
    `;

/**
 * __useGetUserPreferenceQuery__
 *
 * To run a query within a React component, call `useGetUserPreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPreferenceQuery({
 *   variables: {
 *      preferenceKey: // value for 'preferenceKey'
 *   },
 * });
 */

export function useGetUserPreferenceQuery(baseOptions: Apollo.QueryHookOptions<GetUserPreferenceQuery, GetUserPreferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPreferenceQuery, GetUserPreferenceQueryVariables>(GetUserPreferenceDocument, options);
      }

export function useGetUserPreferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPreferenceQuery, GetUserPreferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPreferenceQuery, GetUserPreferenceQueryVariables>(GetUserPreferenceDocument, options);
        }

export type GetUserPreferenceQueryHookResult = ReturnType<typeof useGetUserPreferenceQuery>;

export type GetUserPreferenceLazyQueryHookResult = ReturnType<typeof useGetUserPreferenceLazyQuery>;

export type GetUserPreferenceQueryResult = Apollo.QueryResult<GetUserPreferenceQuery, GetUserPreferenceQueryVariables>;

export const UpdateUserPreferenceDocument = gql`
    mutation UpdateUserPreference($input: UpdateUserPreferenceInput!) {
  updateUserPreference(input: $input) {
    preferenceKey
    values
  }
}
    `;

export type UpdateUserPreferenceMutationFn = Apollo.MutationFunction<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;

/**
 * __useUpdateUserPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferenceMutation, { data, loading, error }] = useUpdateUserPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */

export function useUpdateUserPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>(UpdateUserPreferenceDocument, options);
      }

export type UpdateUserPreferenceMutationHookResult = ReturnType<typeof useUpdateUserPreferenceMutation>;

export type UpdateUserPreferenceMutationResult = Apollo.MutationResult<UpdateUserPreferenceMutation>;

export type UpdateUserPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;
